<template>
    <Modal ref="modal" class="select-columns-modal">
        <template #button="sp">
            <slot name="button" :show-modal="sp.showModal"></slot>
        </template>
        <template #header>
            <div class="h3">Colonnes affichées</div>
        </template>
        <template #body="sp">
            <draggable
                tag="ul"
                class="list-group"
                :list="list"
                :force-fallback="true"
            >
                <li class="cursor-pointer user-select-none list-group-item" v-for="el in list" :key="el.id">
                    <i class="fad fa-list mr-2"></i>
                    <input type="checkbox" class="mr-2" name="columns[]" :value="el.id" v-model="el.visible">

                    {{ el.label }}
                </li>
            </draggable>
        </template>
        <template #footer>
            <button class="btn btn-secondary" @click="closeModal()">Retour</button>
            <button class="btn btn-primary" @click="reloadWithColumns()">Valider</button>
        </template>
    </Modal>
</template>

<script>
import Modal from "../Modal";
import draggable from "vuedraggable";

export default {
    name: 'SelectColumnsModal',

    components: {
        Modal,
        draggable,
    },

    props: {
        columns: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            list: this.columns,
        }
    },

    methods: {
        showModal() {
            this.$refs.modal.showModal();
        },

        closeModal() {
            this.$refs.modal.closeModal();
        },

        reloadWithColumns() {
            location.href = [location.protocol, '//', location.host, location.pathname].join('') + '?columns=' + JSON.stringify(this.list);
        },
    },
}
</script>

<style lang="scss">
.select-columns-modal {
    .modal-container {
        max-width: 400px;
        width: auto;
    }
}
</style>
